import { useReactiveVar } from '@apollo/client'

import { isInternalRouting } from '@web/libs/utils'

import { previousLocationVar } from './useGlobalPreviousRoute'

const useIsPreviousInternalRouting = () => {
  const prevLocation = useReactiveVar(previousLocationVar)

  return isInternalRouting(prevLocation ?? '')
}

export default useIsPreviousInternalRouting
